import type { Customer, CustomerId } from "types/customer"
import type { ControlDesk } from "types/region"
import { PBMenu } from "./pb"
import { thirdRailMenu } from "./thirdRail"
import { getRoadsMenu } from "./roads"
import { getSIPMenu } from "./sip"
import { wagonMenu } from "./wagon"

export const getMenu = (
  customerId: CustomerId,
  userIsSuperAdmin: boolean,
  controlDesk?: ControlDesk,
  customerData?: Customer,
) => {
  switch (customerId) {
    case "NR":
    case "RAIL":
      // The menu is the same for every desk (SRR stays URL-only, as before).
      return getSIPMenu({ tickSheets: true, internal: userIsSuperAdmin })
    case "PB":
      return PBMenu
    case "WAGON":
      return wagonMenu
    case "3RDRAIL":
      return thirdRailMenu
    case "ROADS":
    case "SCC":
    case "MED":
    case "KCC":
    case "WOK":
    case "FMC":
    case "DFI":
    case "HOU":
    case "PET":
    case "RRD":
    case "ANDY":
    case "ABDS":
    case "BCP":
    case "USDEMO":
    case "JER":
    case "CAM":
    case "CFX":
    case "EDI":
    case "LAN":
    case "PIC":
    case "ESUS":
    case "ESS":
    case "DON":
    case "RCM":
    case "WBRK":
    case "LGW":
    case "EGKK":
    case "LHR":
    case "ILN":
    case "NOR":
    case "TAM":
    case "HERT":
    case "GLOU":
    case "MKE":
    case "DVN":
    case "BUCK":
    case "NH":
    case "RR":
    case "STOC":
    case "WSUS":
    case "NBL":
    case "EKFB":
    case "AGB":
      return getRoadsMenu({
        showInternalItems: userIsSuperAdmin,
        customerData,
      })
    default:
      return []
  }
}
